import { z } from 'zod';

/**
 * Composição de passageiros compartilhada pelos cards/tools de voo. Os limites
 * (adultos 1–9, crianças/bebês 0–8) espelham o que as tools do agents podem
 * emitir (search_flights) — um card display nunca aceita contagem impossível.
 */
export const ChatUiFlightPassengersSchema = z.object({
  adults: z.number().int().min(1).max(9),
  children: z.number().int().min(0).max(8).optional(),
  infants: z.number().int().min(0).max(8).optional(),
});
